export default __webpack_public_path__ + "static/media/pictogramBeaconTravel128.9faceda0.svg";